import React, { useState, useEffect } from "react";
import { Menu, Dropdown, Modal, Tooltip, Upload } from 'antd';
import styles from "./scss/profiledetails.module.scss";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { URButton } from "../../../shared/widgets/button";
import { URInput } from "../../../shared/widgets/input";
import { useSelector } from "react-redux";
import { initialStateModel, LoginState } from "../../../models/model";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import { toastInformation, userStatusColor } from "../../../base/callService/common";
import { initiateCall, sendDirectVideoCallRequest, initiateGroupCall, sendDirectGroupVideoCallRequest } from "../../../base/callService/callService";
import { SocketChatService } from "../../../base/socketChatService";
import { generateChatID, handleMute, unmuteNotification, userInfo } from "../../../base/socketChatService/utils";
//import moment from "moment";
import { useRef } from "react";
import ImgCrop from 'antd-img-crop';
import { Cookie, getCookie } from "../../../base/utils";
import axios from "axios";
import { config } from "../../../base/constant";
import { StatusTag } from "../../../shared/widgets/statusTag";
import statusimg from "../../../styles/images/profile-status-icon.svg";
import teamIcn from "../../../styles/images/teamimg.svg";
import ProfileAvatarGroup from "../leftsidebar/profileavatargroup";
import singleIcon from "../../../styles/images/Welaunch_Profile_Pic.svg";
import ImageZoom from "../chatsection/imagezoom";
import { storeHoldTeam } from '../../../base/callService/store_mining';
import store from '../../../context/store/store';
import _ from "lodash";
type profileProps = {
  teamMemberNames: any;
}

type profileState = {

  teamName: string;
  description: string;
  isGroupNameModel: boolean;
  isGroupDescriptionModel: boolean;
  isLeaveModel: boolean;
  isArchiveModel: boolean;
  archiveChat: any;
  isEdited: boolean;
  clearSaved: boolean;
  isOpen: boolean;
}

type popoverState = {
  isArchive: boolean;
  isDelete: boolean;
  archiveChat: any;
  deleteData: any;
  deleteChat: any;
}
export default function ProfileDetails({ teamMemberNames }: profileProps) {

  // const rightSidePanel: chatwindowDetails = useSelector((state: initialStateModel) =>
  //   state.chatWindowReducer);
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  //const contactList: leftsideChats = useSelector((state: initialStateModel) => state.recentchatReducer);
  // const chatDetails:any = useSelector((state: initialStateModel) => state.chatWindowReducer);
  let data: any = store.getState().chatWindowReducer.chatWindowDetails || [];
  const recentChat: any = useSelector((state: initialStateModel) => state.chatSocketRecentReducerState);
  const [ArchiveModal, setArchiveModal] = useState<popoverState>({ isArchive: false, isDelete: false, archiveChat: {}, deleteData: {}, deleteChat: {} })
  let { chatWindowReducer,updatedCallList } = allReducer;
  let { userdetails }: LoginState = allReducer.loginReducer;
  let { chatWindowDetails } = chatWindowReducer;
  let adminValue = chatWindowDetails?.admin_members ? chatWindowDetails?.admin_members.split(",") : [];
  adminValue = adminValue.map((contactdata: any) => (contactdata.trim()));
  const toMail = (mail: any) => {
    let url = 'mailto:' + mail;
    window.open(url);
  }
  useEffect(() => {
    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketService.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
  }, [chatWindowDetails])
  const [profileDetails, setProfileDetails] = useState<profileState>({
    teamName: chatWindowDetails.caller_id ? chatWindowDetails.caller_id : chatWindowDetails.team_name,
    description: chatWindowDetails?.description,
    isGroupNameModel: false,
    isGroupDescriptionModel: false,
    isEdited: false, clearSaved: false,
    isLeaveModel: false, isArchiveModel: false, archiveChat: {}, isOpen: false
  });

  const socketService = useRef<any>(null);
  let enableTeamDetails = chatWindowDetails?.team_id_prefix ||
    chatWindowDetails?.team_id;


  // let data: any = chatWindowDetails || [];

  // const makeAudioCall = () => {
  //   if (chatWindowDetails.ext) { initiateCall(chatWindowDetails.ext, 'audio'); }
  //   else { toastInformation("Please check the number", "failure"); }
  // };

  const makeAudioCall = (data:any) =>{
    if(_.isEmpty(updatedCallList.callDetails) ){
      (data?.team_id)?initiateGroupCall('single',( data?.team_id).toString()):initiateCall(data?.ext,"audio");
    }
    else{ 
      if(updatedCallList.callDetails[0].holdState === true){
        (data.team_id)?initiateGroupCall('single',( data?.team_id).toString()):initiateCall(data?.ext,"audio");
      }else{
        if(data.team_id){
          storeHoldTeam(true,'Group',(data?.team_id).toString())
        }
        else{
          let det:any=updatedCallList.callDetails.findIndex((elem:any)=>{
            return   elem.contact.ext === data.ext
          })
          if(det === -1) 
          { storeHoldTeam(true, 'Normal', data.ext)}
          else{
           toastInformation("You are already in call with this user")
          }
        }
      }
    }
  }



  const showGroupNameModal = () => {
    setProfileDetails({
      ...profileDetails, isGroupNameModel: true,
      teamName: chatWindowDetails.caller_id ? chatWindowDetails.caller_id : chatWindowDetails.team_name
    });
  };

  const closeGroupNameModal = () => {
    setProfileDetails({ ...profileDetails, isGroupNameModel: false });
  };
  const showGroupDescModal = () => {
    setProfileDetails({ ...profileDetails, isGroupDescriptionModel: true, description: chatWindowDetails.description });
  };

  const closeGroupDescModal = () => {
    setProfileDetails({ ...profileDetails, isGroupDescriptionModel: false });
  };


  const updateGroupName = (e: any) => {

    if (e.target.value.length > 50) {

      return true;

    }

    setProfileDetails({ ...profileDetails, teamName: e.target.value });

  };


  const updateTextarea = (e: any) => {

    if (e.target.value.length > 100) {

      return true;
    }
    setProfileDetails({ ...profileDetails, description: e.target.value, isEdited: true });
  };

  const updateTeamDesc = async () => {
    let { description } = profileDetails;
    if (profileDetails.isGroupDescriptionModel && description.trim() === "") {
      return toastInformation("Enter Description", "failure");
    }
    else {

      let data = {
        companyId: chatWindowDetails.company_id,
        teamId: chatWindowDetails.team_id.toString(),
        sipId: chatWindowDetails.team_members,
        teamDescription: description
      }
      socketService.current.editGroupInfo(data);
    }

    setProfileDetails({ ...profileDetails, isGroupDescriptionModel: false, isEdited: false });
    toastInformation("The group description has changed", "success");
  };


  const updateTeam = async () => {
    let { teamName } = profileDetails;

    if (profileDetails.isGroupNameModel && teamName.trim() === "") {
      return toastInformation("Enter Team Name", "failure");
    }
    else {
      let data = {
        companyId: chatWindowDetails.company_id,
        teamId: chatWindowDetails.team_id.toString(),
        sipId: chatWindowDetails.team_members,
        teamName: teamName
      }
      socketService.current.editGroupInfo(data);
    }

    setProfileDetails({ ...profileDetails, isGroupNameModel: false });
    toastInformation("The group name has changed", "success");

  };
  const uploadPicture = async (e: any) => {
    let token: any = getCookie("ssoToken");
    let formData = new FormData();
    formData.append("pic", e)

    const url: string = `${config().CHAT_RESTAPI_URL}/upload/profile?type=team&teamId=${chatWindowDetails.team_id.toString()}`;

    var authkey = {
      "Content-Type": "application/json",
      Authorization: token
    };
    await axios
      .put(url, formData, { headers: authkey })
      .then((response: any) => {

        if (response.data.statusCode === 200) {

          let data = {
            companyId: chatWindowDetails.company_id,
            teamId: chatWindowDetails.team_id.toString(),
            sipId: chatWindowDetails.team_members,
            profileImage: response.data.files.geturl
          }
          socketService.current.editGroupInfo(data);
          toastInformation("Team Profile Picture Changed", "success");
        }
      }).catch(function (error: any) { toastInformation("Unsupported file format", "failure"); console.log("error is", error); });

  };




  const leaveFromTeam = async () => {

    let groupLeaveMembersInfo = {
      companyId: userdetails.company_id,
      teamId: chatWindowDetails?.team_id,
      leaveMemberSipId: userdetails.sip_login_id.toString()
    };
    socketService.current.leaveMember(groupLeaveMembersInfo);
    setProfileDetails({ ...profileDetails, isLeaveModel: false });
    toastInformation("Team Member leaved", "success");


  };

  const handleCancel = () => {
    setArchiveModal({ ...ArchiveModal, isDelete: false, deleteData: {}, deleteChat: {} })
  }

  /**
   * Favourite Contact in right side Panel
   * @param data 
   */


  const favContacts = (contactDetails: any) => {

    let chatId: any = contactDetails.sip_login_id ?
    generateChatID(userInfo().fromID, contactDetails?.sip_login_id.toString()) : contactDetails?.team_id.toString();
    let teamMemberFavourite = contactDetails?.team_members_favourite ? contactDetails?.team_members_favourite.split(",").map((ele: any) => ele.trim()): [];
    let chatDetails = { 
      chatId : chatId,
      settingsKey : "isFavourite",
      toSipId:contactDetails?.sip_login_id ? contactDetails?.sip_login_id?.toString():contactDetails?.team_id?.toString(),
      type: contactDetails?.sip_login_id ? 1:2,
      status : (contactDetails?.is_favourite || (Array.isArray(teamMemberFavourite) && teamMemberFavourite.length>0 &&
      teamMemberFavourite.indexOf(userdetails.sip_login_id)>-1))  ? 0:1,
      phoneNumber : contactDetails?.ext ?  contactDetails?.ext :""};
      const timer = setTimeout(()=>{
        socketService.current.updateRecentChatSettings(chatDetails);
        socketService.current.toastUndo("","")},3000);
      if((!contactDetails?.is_favourite && contactDetails?.sip_login_id) || ((Array.isArray(teamMemberFavourite) &&
      teamMemberFavourite.indexOf(userdetails.sip_login_id)===-1) && contactDetails?.team_id)){
        socketService.current.toastUndo("Added to favourites",timer, 'favourite');
      } else {
        socketService.current.toastUndo("Removed from favourites",timer, 'unfavourite');
      }

  }

  const closeLeaveModal = () => {
    setProfileDetails({ ...profileDetails, isLeaveModel: false });
  }
  const openLeaveModal = () => {
    let adminValue = chatWindowDetails?.admin_members ? chatWindowDetails?.admin_members.split(",") : [];
    let teamMember = chatWindowDetails?.team_members ? chatWindowDetails?.team_members.split(",") : []
    adminValue = adminValue.map((contactdata: any) => (contactdata.trim()));
    (adminValue.length === 1 && adminValue.includes(userdetails.sip_login_id) && teamMember.length !== 1) ?
      toastInformation('To leave this group, assign an Admin', "failure")
      : setProfileDetails({ ...profileDetails, isLeaveModel: true });

  }
  const openArchiveModal = () => {
    setProfileDetails({ ...profileDetails, isArchiveModel: true });
  }
  const cancelArchive = () => {
    setProfileDetails({ ...profileDetails, isArchiveModel: false });
  }
  const clearChat = (contact: any) => {
    let { contactReducer } = allReducer;
    let workContact = contactReducer?.workContactsnew;
    let teamContact = contactReducer?.teamContacsnew;
    let toContact = contact?.type === 1 ? workContact[contact?.to] : teamContact["con" + contact?.chatId];
    console.log("To Contact ---->", toContact);
    setArchiveModal({ ...ArchiveModal, isDelete: true, deleteData: toContact, deleteChat: contact })
  }
  const makevideoCall = (data: any) => {


    if(data?.ext){
    sendDirectVideoCallRequest(data)
  }
  else {
    sendDirectGroupVideoCallRequest(data.teammembersdetails)
  }
  };
  // const menuItemClick = (e:any)=>{
  //   let status = 0;
  //   let timeStamp:any = '';
  //   let mutetype = 0;
  //   if(e.key==="Until 8:00 AM"){
  //     var now  = new Date();
  //     now.setDate(now.getDate() + 1)
  //     now.setHours(8);
  //     now.setMinutes(0);
  //     now.setMilliseconds(0);
  //     timeStamp = moment(now).valueOf();
  //     status = 1;
  //     mutetype = 0;
  //   } else if(e.key==="1 Hr"){
  //     timeStamp = moment().add(2, 'hours').valueOf();
  //     status = 1;
  //     mutetype = 1;
  //   } else if(e.key==="12 Hr"){
  //     timeStamp= moment().add(12, 'hours').valueOf();
  //     status = 1;
  //     mutetype = 2;
  //   }else if(e.key==="1 Week"){
  //     timeStamp= moment().add(7, 'days').valueOf();
  //     status = 1;
  //     mutetype = 3;
  //   }else if(e.key==="Always"){
  //     timeStamp= moment().add(24, 'hours').valueOf();
  //     status = 1;
  //     mutetype = 4;
  //   } else if(e.key==="Unmute"){
  //     timeStamp='';
  //     status = 0;
  //     mutetype = 5;
  //   }

  //   let chatDetails = { 
  //     chatId : chatWindowDetails?.sip_login_id ? generateChatID(userInfo().fromID, 
  //     chatWindowDetails?.sip_login_id.toString()): chatWindowDetails?.team_id,
  //     settingsKey : "isMuted",
  //     toSipId : chatWindowDetails?.sip_login_id?chatWindowDetails?.sip_login_id:
  //     chatWindowDetails?.team_id.toString(),
  //     status : status,
  //     muteTimestamp:timeStamp,
  //     muteType:mutetype
  //   };

  //   console.log("chatDetails --->",chatDetails);

  //     const timer = setTimeout(()=>{
  //     socketService.current.updateRecentChatSettings(chatDetails);socketService.current.toastUndo("","")},3000);
  //     socketService.current.toastUndo("Chat Muted Successfully",timer, 'isMuted');
  // }
  // const  unmuteNotification = () =>{

  //   let chatDetails = { 
  //     chatId : chatWindowDetails?.sip_login_id ? generateChatID(userInfo().fromID, 
  //     chatWindowDetails?.sip_login_id.toString()): chatWindowDetails?.team_id,
  //     settingsKey : "isMuted",
  //     status : 0,
  //     muteTimestamp:'',
  //     "muteType" :2
  //   };
  //   const timer = setTimeout(()=>{
  //     socketService.current.updateRecentChatSettings(chatDetails);socketService.current.toastUndo("","")},3000);
  //     socketService.current.toastUndo("Chat Unmuted Successfully",timer, 'isMuted');
  // }
  const menu1 = (
    <Menu onClick={(e: any) => handleMute(e, chatWindowDetails)}>
      <Menu.Item key={"Until 8:00 AM"}>Until 8:00 AM</Menu.Item>
      <Menu.Item key={"1 Hr"}>1 Hr</Menu.Item>
      <Menu.Item key={"12 Hr"}>12 Hrs</Menu.Item>
      <Menu.Item key={"1 Week"}>1 Week</Menu.Item>
      <Menu.Item key={"Always"}>Always</Menu.Item>
    </Menu>
  );
  // let leftMembers = chatWindowDetails?.leaveTeamMembers ? chatWindowDetails?.leaveTeamMembers.split(",").map((ele: any) => ele.trim()) : [];
  let nameShow = chatWindowDetails?.caller_id ?
    chatWindowDetails.caller_id : chatWindowDetails?.team_name;
  const recentDetails = recentChat.recentChatList[chatWindowDetails?.sip_login_id ?
    chatWindowDetails?.sip_login_id : "con" + chatWindowDetails.team_id];
  const fromID = parseInt(userInfo().fromID);

  const archiveAction = (key: any) => {
    let chatDetails = {
      chatId: chatWindowDetails?.sip_login_id ? generateChatID(userInfo().fromID,
        chatWindowDetails?.sip_login_id.toString()) : chatWindowDetails?.team_id,
      settingsKey: "isArchive",
      status: key === "archive" ? 1 : 0
    }
    socketService.current.updateRecentChatSettings(chatDetails);
    setProfileDetails({ ...profileDetails, isArchiveModel: false });
  };
  const deleteAction = () => {
    let chatDetails = {
      chatId: ArchiveModal?.deleteChat?.chatId,
      savedChatsatus: profileDetails?.clearSaved === true ? 0 : 1
    }
    socketService.current.clearChatMessage(chatDetails);
    setArchiveModal({ ...ArchiveModal, isDelete: false, deleteData: {}, deleteChat: {} })

  };
  const clearOnchange = (e: any) => {
    setProfileDetails({ ...profileDetails, clearSaved: e.target.checked });
  }
  const viewAvatar = () => {
    setProfileDetails({ ...profileDetails, isOpen: !profileDetails.isOpen });
  }
  const removeAvatar = async () => {

    let profileImageUrl: any = chatWindowDetails.profile_image_url;
    let token: any = getCookie("ssoToken");
    //let userInfo: any = getCookie('userinfo');
    const userInfosess: any = sessionStorage.getItem("userinfo");
    let parse = JSON.parse(userInfosess);
    const url: string = `${config().CHAT_RESTAPI_URL}/upload/profile`;
    const profilepathempty = profileImageUrl.substring(0, profileImageUrl.lastIndexOf("/"));
    const profileavatar = profilepathempty + '/avatar.png';
    var authkey = {
      "Content-Type": "application/json",
      Authorization: token
    };
    await axios
      .delete(url, { data: { profileImageUrl: profileImageUrl, "type": "team" }, headers: authkey })
      .then(async (response: any) => {
        if (response.data.statusCode === 200) {
          let data = {
            companyId: chatWindowDetails.company_id,
            teamId: chatWindowDetails.team_id.toString(),
            sipId: chatWindowDetails.team_members,
            profileImage: response.data.files.geturl
          }
          socketService.current.editGroupInfo(data);

        }
      }).catch(function (error: any) { console.log("error is", error); });

  }

  const menu = (
    <>
      {chatWindowDetails?.team_id && chatWindowDetails?.admin_members && chatWindowDetails?.admin_members.includes(userdetails?.sip_login_id.toString().trim()) &&

        <Menu >
          <Menu.Item>
            <ImgCrop onModalOk={uploadPicture} onModalCancel={handleCancel} modalOk="Crop" >
              <Upload >Update Avatar</Upload></ImgCrop>
          </Menu.Item>
          <Menu.Item onClick={viewAvatar}>View Avatar</Menu.Item>
          <Menu.Item onClick={removeAvatar}>Remove Avatar</Menu.Item>
        </Menu>}
    </>
  );
  let teamMemberOnly = chatWindowDetails?.team_members ? chatWindowDetails?.team_members.split(",").map((ele: any) => ele.trim()) : [];
  let teamMemberFavourite = chatWindowDetails?.team_members_favourite ? chatWindowDetails?.team_members_favourite.split(",").map((ele: any) => ele.trim()) : [];
  let teamMemberMuted = chatWindowDetails?.team_members_muted ? chatWindowDetails?.team_members_muted.split(",").map((ele: any) => ele.trim()) : [];
  let currentTeamMember = Array.isArray(teamMemberMuted) && teamMemberMuted.length > 0 ? teamMemberMuted.map((value: any) => value.split('_')[0]) : [];
  //console.log(chatWindowDetails?.admin_members?.includes(userdetails.sip_login_id.toString()),"teamMemberMuted --->");
  let colorIndex = allReducer.recentChatTabReducer?.tabrecentindex > 7 ? (allReducer.recentChatTabReducer?.tabrecentindex - Math.floor((allReducer.recentChatTabReducer?.tabrecentindex / 8)) * 8) + 1
    : allReducer.recentChatTabReducer?.tabrecentindex + 1
    const isTeamMember = chatWindowDetails?.team_id && teamMemberOnly.includes(userdetails?.sip_login_id);
    const isBlocked = chatWindowDetails?.is_blocked === 1;
    const isFavourite = chatWindowDetails?.is_favourite === 0;
    const hasFavourite = Array.isArray(teamMemberFavourite) && teamMemberFavourite.includes(userdetails?.sip_login_id);

  return (
    <>
      {/* {profileDetails.isOpen &&
            <FilePreview isOpen={profileDetails.isOpen}
            data={fileState.imagefiledata}
            groupdata={fileState.allFilesList}
            previewopen={FilePreviewer} />} */}
      <div className={styles.mainprofiles}>
        <div className={styles.profiledetails}>
          <Dropdown overlay={menu} overlayClassName="outPutLangSelection" trigger={['click']} placement="bottom">

            <div className={styles.usergroups}>
              {
                chatWindowDetails?.is_blocked === 1 ?   <URAvatarGroup className={`lefts size60 ${chatWindowDetails?.profile_image_url ? "avatarWithImg" : ""}`}
                profileInfo={<> <img src={singleIcon} alt="team icon" />
                </>} />:
                enableTeamDetails && chatWindowDetails.team_id && chatWindowDetails.profile_image_url ?

                  <URAvatarGroup className={`lefts size60 ${chatWindowDetails?.profile_image_url ? "avatarWithImg" : ""}`}
                    profileInfo={<> {chatWindowDetails?.profile_image_url ?
                      <img src={chatWindowDetails?.profile_image_url} alt="" />
                      : <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>}
                    </>}
                  /> :
                  //   enableTeamDetails && teamMemberNames?.length > 4 ?
                  // <URAvatarGroup className='lefts size82 four'
                  //   profileInfo={<><span>{teamMemberNames[0] === undefined ? 1 :
                  //     teamMemberNames[0]?.charAt(0).toUpperCase()}
                  //   </span><span>{teamMemberNames[1] === undefined ? 1 : teamMemberNames[1]?.charAt(0).toUpperCase()}</span>
                  //     <span>{teamMemberNames[2] === undefined ? 1 : teamMemberNames[2]?.charAt(0).toUpperCase()}</span>
                  //    <span>
                  //      +{teamMemberNames?.length < 99 ?teamMemberNames?.length - 4:"99"}</span> 
                  //       </>}
                  // /> :
                  // enableTeamDetails && teamMemberNames?.length > 3 ?
                  //   <URAvatarGroup className='lefts size82 four'
                  //     profileInfo={<><span>{teamMemberNames[0] === undefined ? 1 :
                  //       teamMemberNames[0]?.charAt(0).toUpperCase()}
                  //     </span><span>{teamMemberNames[1] === undefined ? 1 : teamMemberNames[1]?.charAt(0).toUpperCase()}</span>
                  //       <span>{teamMemberNames[2] === undefined ? 1 : teamMemberNames[2]?.charAt(0).toUpperCase()}</span>
                  //       <span>{teamMemberNames[3] === undefined ? 1 : teamMemberNames[3]?.charAt(0).toUpperCase()}</span>
                  //         </>}
                  //   /> : enableTeamDetails && teamMemberNames?.length === 3 ?
                  //     <URAvatarGroup className='lefts size82 three'
                  //       profileInfo={<><span>{teamMemberNames[0] === undefined ? 1 :
                  //         teamMemberNames[0]?.charAt(0).toUpperCase()}</span>
                  //         <span>{teamMemberNames[1] === undefined ? 1 : teamMemberNames[1]?.charAt(0).toUpperCase()}</span>
                  //         <span>{teamMemberNames[2] === undefined ? 1 : teamMemberNames[2]?.charAt(0).toUpperCase()}</span></>}
                  //     /> : enableTeamDetails && teamMemberNames?.length === 2 ?
                  //       <URAvatarGroup className='lefts size82 two'
                  //         profileInfo={<><span>{teamMemberNames[0] === undefined ? 1 :
                  //           teamMemberNames[0]?.charAt(0).toUpperCase()}</span>
                  //            <span>{teamMemberNames[0] === undefined ? 1 : teamMemberNames[1]?.charAt(0).toUpperCase()}</span>
                  //         <span>{teamMemberNames[1] === undefined ? 1 : teamMemberNames[2]?.charAt(0).toUpperCase()}</span></>}/>:
                  //         enableTeamDetails && teamMemberNames?.length === 1 ?
                  //       <URAvatarGroup className='lefts size82 '
                  //         profileInfo={<><span>{
                  //           <span>{teamMemberNames[0] === undefined ? 1 : teamMemberNames[0]?.charAt(0).toUpperCase()}</span>}</span>
                  //           </>}
                  //           /> :
                  <>
                    <URAvatarGroup className={`lefts size60 colorBG${colorIndex} ${chatWindowDetails?.ImageURL ? "avatarWithImg" : ""}`}
                      profileInfo={<> {chatWindowDetails?.ImageURL || chatWindowDetails?.profile_url ?
                        <img src={chatWindowDetails?.ImageURL || chatWindowDetails?.profile_url} alt="" />

                        : <>{chatWindowDetails?.team_id ? <img className="ifDummy" src={teamIcn} alt="team icon" /> :
                          <span>{chatWindowDetails?.first_name?.charAt(0).toUpperCase() + chatWindowDetails?.last_name?.charAt(0).toUpperCase()}</span>
                        }</>}
                        {chatWindowDetails?.caller_id && <URStatusDot className={userStatusColor(chatWindowDetails?.user_status, 'big')} />}
                      </>}
                    />
                  </>
              }
              {chatWindowDetails?.team_id && chatWindowDetails?.admin_members && chatWindowDetails?.admin_members.includes(userdetails?.sip_login_id.toString().trim()) && <>
                <span className={styles.updateTeamImage}></span>

              </>}
            </div>
          </Dropdown>

          <h3>{enableTeamDetails && <span className="icon_lock"></span>}

            {nameShow && <Tooltip mouseEnterDelay={0.5} title={nameShow}
              className='cusTooltip' overlayClassName='customTooltip tooltiplftsizesm'>
              <b>{nameShow} </b>
            </Tooltip>}
            <b>{nameShow && nameShow.length > 0 && nameShow.length < 15}</b>
            {enableTeamDetails && chatWindowDetails?.admin_members && chatWindowDetails?.admin_members?.includes(userdetails.sip_login_id.toString()) ? <span className={styles.edit}
              onClick={showGroupNameModal}>Edit</span> : null}
          </h3>
          {chatWindowDetails?.sip_login_id && <div className={styles.workingStatus}>
            <StatusTag className='mystatus' name="Working remotely" />
            {/* <span><img src={statusimg} alt="" /></span> */}
          </div>}
          <ul className={styles.clickBtn}>
          {<>
              {((chatWindowDetails?.team_id && teamMemberOnly && Array.isArray(teamMemberOnly) &&
              teamMemberOnly.includes(userdetails?.sip_login_id.toString().trim())) || chatWindowDetails?.sip_login_id) &&
              chatWindowDetails?.sip_login_id !== userdetails?.sip_login_id && 
              <li onClick={()=>makeAudioCall(data)} className={`${chatWindowDetails?.is_blocked === 1 && 'blockdisabled'}`}>
                <Tooltip placement="top" title={"Call"}>
                  <span className="icon__clickToCall"></span>
                </Tooltip>
              </li>}

            </>}
            {((chatWindowDetails?.team_id && teamMemberOnly && Array.isArray(teamMemberOnly) &&
              teamMemberOnly.includes(userdetails?.sip_login_id.toString().trim())) || chatWindowDetails?.sip_login_id) &&
              chatWindowDetails?.sip_login_id !== userdetails.sip_login_id &&
              <li onClick={() => makevideoCall(chatWindowDetails)} className={`${chatWindowDetails?.is_blocked === 1 && 'blockdisabled'}`}>
                <Tooltip placement="top" title={"Video Call"}>
                  <span className="icon__clicktoMeet"></span>
                </Tooltip>
              </li>}

     
            {chatWindowDetails?.team_id && teamMemberOnly && Array.isArray(teamMemberOnly) &&
              teamMemberOnly.includes(userdetails.sip_login_id.toString().trim())
              && currentTeamMember.indexOf(userdetails.sip_login_id) === -1 ?
              <li >
                <Tooltip mouseEnterDelay={0.5} placement="top" title="Mute notifications">
                  <Dropdown trigger={["click"]} overlay={menu1} placement="bottomCenter"><span className="icon__clickToNotify"></span></Dropdown>
                </Tooltip>
              </li> :
              !chatWindowDetails?.is_muted && chatWindowDetails?.sip_login_id ? <li className={`${chatWindowDetails?.is_blocked === 1 && 'blockdisabled'}`}>
                <Tooltip mouseEnterDelay={0.5} placement="top" title="Mute notifications">
                  <Dropdown trigger={["click"]} overlay={menu1} placement="bottomCenter"><span className="icon__clickToNotify"></span></Dropdown>
                </Tooltip>
              </li> 
                  : null

            }
            {(teamMemberOnly && Array.isArray(teamMemberOnly) &&
              teamMemberOnly.includes(userdetails.sip_login_id.toString().trim()) && currentTeamMember.indexOf(userdetails.sip_login_id) > -1) || chatWindowDetails?.is_muted ?
              <li onClick={() => unmuteNotification(chatWindowDetails)}><Tooltip mouseEnterDelay={0.5} placement="top" title="Unmute notifications">
                <span className={((currentTeamMember.indexOf(userdetails.sip_login_id) > -1) ||
                  (chatWindowDetails?.is_muted && chatWindowDetails?.sip_login_id)) ? "icon__clickToNotifyMute" : "icon__clickToNotifyMute"}></span>
              </Tooltip> </li> : null}
              <li onClick={() => favContacts(chatWindowDetails)} className={`starFav ${isBlocked && 'blockdisabled'}`}>
                  <Tooltip placement="top" title={isTeamMember ? hasFavourite ? 'Remove from Favourites' : 'Add to Favourites' : isFavourite ? 'Favourite' : 'Unfavourite'}>
                    <span className={isTeamMember ? hasFavourite ? 'icon__favFilled' : 'icon__fav':isFavourite ? 'icon__fav' : 'icon__favFilled'}></span>
                  </Tooltip>
              </li>
              {/* {((chatWindowDetails?.team_id && teamMemberOnly && Array.isArray(teamMemberOnly) &&
              teamMemberOnly.includes(userdetails?.sip_login_id.toString().trim())) || chatWindowDetails?.sip_login_id) &&
              chatWindowDetails?.sip_login_id !== userdetails?.sip_login_id
               && <li  onClick={() => favContacts(chatWindowDetails)} className={`starFav ${chatWindowDetails?.is_blocked === 1 && 'blockdisabled'}`} >
                <Tooltip placement="top" title={Array.isArray(teamMemberFavourite) &&
                 chatWindowDetails?.is_favourite === 0
                  ? "Favourite" : "Unfavourite"}>
                   <span className={chatWindowDetails?.is_favourite === 0 ? "icon__fav" : "icon__favFilled"} ></span>
                </Tooltip>
              </li> } */}
          
            {/* {(teamMemberOnly && Array.isArray(teamMemberOnly) &&
              teamMemberOnly.includes(userdetails.sip_login_id.toString().trim()) && currentTeamMember.indexOf(userdetails.sip_login_id) > -1) || chatWindowDetails?.is_muted ?
              <li onClick={() => unmuteNotification(chatWindowDetails)}><Tooltip mouseEnterDelay={0.5} placement="top" title="Unmute all notifications">
                <span className={((currentTeamMember.indexOf(userdetails.sip_login_id) > -1) ||
                  (chatWindowDetails?.is_muted && chatWindowDetails?.sip_login_id)) ? "icon_fillnotification" : "icon_belloutline"}></span>
              </Tooltip> </li> : null}
            {!chatWindowDetails.team_id && <li><Dropdown overlay={
              <><Menu className="drpdownNotification">
                <><Menu.Item onClick={() => clearChat(recentDetails)}>Clear Chat</Menu.Item>
                <Menu.Item onClick={() => favContacts(chatWindowDetails.is_favourite
                  === 0 ? 1 : 0)}>{chatWindowDetails.is_favourite === 0
                    ? "Favourite" : "Remove from Favourite"}</Menu.Item>
                  {recentDetails?.settings?.isArchive?.["s" + fromID] ? <Menu.Item onClick={() => archiveAction("unarchive")}>UnArchive Chat</Menu.Item> :
                    <Menu.Item onClick={openArchiveModal}>Archive Chat</Menu.Item>}
                </>
              </Menu>
              </>

            } trigger={['click']} placement="bottomRight">
              <span className="icon_overflow"></span></Dropdown></li>}

            {enableTeamDetails && teamMemberOnly.includes(userdetails.sip_login_id.toString().trim()) && <li className='cusTooltip'><Dropdown trigger={['click']} overlay={
              <Menu>
                <Menu.Item onClick={() => clearChat(recentDetails)}>Clear Chat</Menu.Item>
                {recentDetails?.settings?.isArchive?.["s" + fromID] ? <Menu.Item onClick={() => archiveAction("unarchive")}>UnArchive Chat</Menu.Item> :
                  <Menu.Item onClick={openArchiveModal}>Archive Chat</Menu.Item>}
                <Menu.Item onClick={openLeaveModal}>Leave Team</Menu.Item>
              </Menu>
            } placement="bottomRight">
              <span className="icon_overflow"></span></Dropdown></li>} */}
          </ul>
          {/* <div className={styles.profileDt}>
            <div className={styles.userProfileDetails}>
              <div className={styles.userProfilelabel}>
                <p>Department</p>
              </div>
              <div className={styles.userProfileDt}>
                <p>{chatWindowDetails?.department ? chatWindowDetails?.department : 'Not Available'}</p>
              </div>
            </div> */}

          {/* <div className={styles.userProfileDetails}>
              <div className={styles.userProfilelabel}>
                <p>Extension</p>
              </div>
              <div className={styles.userProfileDt}>
                {chatWindowDetails?.ext ?
                  <p onClick={makeAudioCall}>{chatWindowDetails?.ext && chatWindowDetails?.ext}</p> :
                  (<p>Not Available</p>)}
              </div>
            </div> */}

          {/* <div className={styles.userProfileDetails}>
              <div className={styles.userProfilelabel}>
                <p>Email Address</p>
              </div>
              <div className={styles.userProfileDt}>
                {chatWindowDetails?.email_id ? <div className={styles.emailtxt}><Tooltip placement="top" title={chatWindowDetails?.email_id}><span onClick={() => toMail(chatWindowDetails?.email_id)}>
                  {chatWindowDetails?.email_id} </span></Tooltip></div> :

                  <p>Not Available</p>}
              </div>
            </div>
          </div> */}
          {/* <div className={`${styles.rowFlex} `}>
                <div className={styles.leftsidetxt}>
                   <p>My Numbers</p>
                </div>
                <div className={styles.rightsidetxt}>
                <div className={styles.phoneNumbrtxt}>
                   
                   { chatWindowDetails?.directNum ?  <Tooltip placement="top" title="Company number">
                       <p> {chatWindowDetails?.directNum}</p>
                    </Tooltip>:  <p>Not Available</p>}
                   
                  </div>
                  <div className={styles.phoneNumbrtxt}>
                  { chatWindowDetails?.mobileno?  <Tooltip placement="top" title="Mobile number">
                      <p onClick={makeAudioCall}>
                        {chatWindowDetails?.mobileno}</p>
                        </Tooltip>:<p>Not Available</p>}
                        </div>
                </div>
             </div> */}
          {/* <h4>{chatWindowDetails.email_id ?
            chatWindowDetails.email_id : ""}</h4> */}
          {enableTeamDetails && <p >{chatWindowDetails?.description ?
            <span>{chatWindowDetails?.description.length > 30 ?
              chatWindowDetails?.description.substring(0, 40) + "..." :
              chatWindowDetails?.description}</span>
            : enableTeamDetails && adminValue && adminValue.includes(userdetails.sip_login_id) && teamMemberOnly.includes(userdetails.sip_login_id.toString().trim()) ?
              <span className={styles.ifdescEmpty}>Add a description(Just be aware anyone can read it)</span> : null
          }
            {enableTeamDetails && adminValue && adminValue.includes(userdetails.sip_login_id) && teamMemberOnly.includes(userdetails.sip_login_id.toString().trim()) ?
              <span className={styles.edit} onClick={showGroupDescModal}>Edit</span> : null}
          </p>}



        </div>
      </div>

      {/*       <Modal visible={isModalVisible} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} />
        <h2>Remove Member</h2>
        <p>Are you sure you want to clear this chat? You cannot retrieve the unsaved messages.</p>
        <div className={styles.footersection}>
          <p><input type="checkbox" name="" />Keep saved messages</p>
          <URButton className={styles.cancelbtn} name="Cancel"></URButton>
          <URButton className={styles.savebtn} onClick={handleCancel} name="Confirm"></URButton>
        </div>
      </Modal> */}

      <Modal visible={profileDetails.isArchiveModel} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={cancelArchive} />
        <h2>Archive Chat?</h2>
        <p>When you archive a chat, you will no longer receive any notifications from this chat,
          and the chat will be removed from your Recent Chat(s) list. Click button Confirm to proceed.</p>
        <div className={styles.footersection}>
          <URButton className="urButton buttonWhite buttonMd mr8" onClick={cancelArchive} name="Cancel"></URButton>
          <URButton className="urButton buttonRed buttonMd" onClick={() => archiveAction("archive")} name="Confirm"></URButton>
        </div>
      </Modal>

      <Modal visible={profileDetails.isLeaveModel} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={closeLeaveModal} />
        <h2>Leave {chatWindowDetails.team_name}?</h2>
        {/* <p>Team members will be notified that you left. You can rejoin anytime.</p>  */}
        {/* Private Leave Team */}
        <p>You can no longer see, send, or receive any of the team messages. To rejoin
          this team, you`ll need an invite from the admin... </p>
        {/* <p>You can no longer see, send, or receive any of the team messages. To rejoin this team, 
          you'll need an invite from the Admin.</p> */}
        <div className={styles.footersection}>
          <URButton className="urButton buttonWhite buttonMd mr8" onClick={closeLeaveModal} name="Cancel"></URButton>
          <URButton className="urButton buttonRed buttonMd" onClick={leaveFromTeam} name="Confirm"></URButton>
        </div>
      </Modal>


      <Modal visible={profileDetails.isGroupNameModel} className={`${styles.editprofilename} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={closeGroupNameModal} />
        <h2>Edit Team Name</h2>
        <div className={styles.editGroupName}>
          <URInput placeHolder="Edit Teamname" className="editprofilename" value={profileDetails.teamName}
            onChange={(e: any) => updateGroupName(e)} />
          {<span className={styles.inputright}>{profileDetails?.teamName?.length}</span>}
        </div>
        <div className={styles.footersection}>
          <URButton className="urButton buttonWhite buttonMd mr8" name="Cancel" onClick={closeGroupNameModal}></URButton>
          <URButton className="urButton buttonBlue buttonMd" onClick={updateTeam} name="Save"></URButton>
        </div>
      </Modal>

      <Modal visible={profileDetails.isGroupDescriptionModel}
        className={`${styles.editprofilename} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={closeGroupDescModal} />
        <h2>Edit Team Description</h2>
        <textarea name="" placeholder="Enter description" maxLength={100} rows={3}
          className="editprofilename textareasnew" value={profileDetails?.description}
          onChange={updateTextarea}></textarea>
        <p className={styles.valueinput}>{profileDetails?.description && profileDetails?.description?.length}</p>
        <div className={styles.footersection}>
          <URButton className={styles.cancelbtn} onClick={closeGroupDescModal} name="Cancel"></URButton>
          <URButton className={styles.savebtn} disabled={profileDetails.isEdited ? false : true}
            onClick={updateTeamDesc} name="Save"></URButton>
        </div>
      </Modal>

      <Modal visible={ArchiveModal.isDelete}
        className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span onClick={handleCancel} className={`icon_close ${styles.cursorTop}`} />
        <h2>Clear Chat?</h2>
        <p>Are you sure you want to clear this chat? You cannot retrieve the unsaved messages.</p>
        <p><input type="checkbox" name="" onChange={(e: any) => clearOnchange(e)} />Keep saved messages</p>

        <div className={styles.footersection}>
          <URButton className="urButton buttonWhite buttonMd mr8" onClick={handleCancel} name="Cancel"></URButton>
          <URButton className="urButton buttonRed buttonMd" onClick={deleteAction} name="Clear Chat"></URButton>
        </div>
      </Modal>

      <Modal visible={profileDetails.isOpen} className="imagepreviewmodal">
        <div className="modalheaders">
          <h2>Profile Preview</h2>
          <ul>
            <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Close'}
            >
              <span className="icon_close" onClick={viewAvatar} >
              </span></Tooltip></li>
          </ul>
        </div>
        <div className="imagepreview">
          <ImageZoom url={chatWindowDetails?.profile_image_url} ></ImageZoom>
        </div>
      </Modal>



    </>
  );
};




